export const environment = {
  production: false,
  apiUrl: "http://localhost:3001/api/v1",
  appUrl: "http://localhost:4200",
  LOCAL: true,
  useMockSearch: false,
};
